<template>
    <component
        :is="type"
        :class="{
            'List pl-5': variant === 'default',
            'define-mentoring-list': variant === 'define-mentoring',
            'muted': variant === 'muted'
        }"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
interface Props {
    variant?: 'default' | 'define-mentoring' | 'muted'
    type?: 'ul' | 'ol'
}

withDefaults(defineProps<Props>(), {
    variant: 'default',
    type: 'ul'
})
</script>

